import React from "react";
import { JAPIPublicationLoader } from "../latestResearch/publications/JAPIPublicationLoader";
import { FilterSearchButton } from "./filtering/FilterSearchButton";
import { Form } from "react-bootstrap";
import { FilterPanel } from "./filtering/FilterPanel";
import PillsBar from "./searchBar/PillsBar";
import { AutoCompleteSearchBox } from "./searchBar/AutoCompleteSearchBox";
import { useSelector } from "react-redux";
import { gotoSearchResultsPage, getQueryString } from "./api/filterUrlMaker";
import { Redirect } from "react-router";
import QueryString from "query-string";
import { PUB_LANG } from "redux/slices/api/initialisePreferences";
import { use100vh } from "react-div-100vh";

export const Search = () => {
  const { filter } = useSelector((state) => state.filter);
  const maxHeight = use100vh() - 65; // IOS Bug fix: 100vh minus url bar

  return (
    <Form onSubmit={(e) => onSubmit(e)} className="bg-light d-flex flex-column" style={{ maxHeight: maxHeight }}>
      <section className="px-2 maxw-600 w-100">
        <AutoCompleteSearchBox />
        <PillsBar filter={filter} />
      </section>

      <JAPIPublicationLoader
        showSpinner={false}
        scrollToTop={false}
        aggregations={{
          language: "",
          "companies.name.en": "",
          "companies.name.ja": "",
          "analysts.name.en": "",
          "analysts.name.ja": "",
          "assetClasses.en": "",
          "assetClasses.ja": "",
          "gicsSectors.ja": "",
          "gicsSectors.en": "",
          "gicsIndustryGroups.en": "",
          "gicsIndustryGroups.ja": "",
          "periodicals.en": "",
          "periodicals.ja": "",
          "reportTitles.en": "readCount",
          "reportTitles.ja": "readCount",
          "reportTypes.en": "",
          "reportTypes.ja": "",
        }}
        render={(publications, aggregations, response) => (
          <>
            <FilterPanel filter={filter} publications={publications} aggregations={aggregations} />
            <FilterSearchButton filter={filter} results={response} />
          </>
        )}
      />
    </Form>
  );
};

export const GotoSearch = () => {
  const preferences = useSelector((state) => state.preferences);
  const queryString = {
    ...getQueryString(),
    Language: preferences[PUB_LANG],
  };

  return <Redirect to={"/Search?" + QueryString.stringify(queryString)} />;
};

const onSubmit = (e) => {
  // try old Web@Work compatibility
  e.preventDefault();
  e.stopPropagation();
  gotoSearchResultsPage();
  return false;
};
